var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningIcon = function SvgWarningIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#bf3939",
    d: "m19.6 9.996-2.13 2.426.298 3.211-3.15.716-1.65 2.775L10 17.85l-2.967 1.283-1.65-2.775-3.15-.716.297-3.22L.4 9.996 2.53 7.56l-.297-3.212 3.15-.707L7.034.867 10 2.14 12.968.867l1.65 2.775 3.15.716-.297 3.211zm-2.33 0-1.597-1.842.21-2.435-2.392-.523-1.239-2.121L10 4.044l-2.251-.97-1.24 2.122-2.39.515.209 2.434-1.597 1.85 1.597 1.833-.21 2.444 2.391.524 1.24 2.12L10 15.94l2.252.969 1.24-2.112 2.39-.533-.209-2.435zm-8.142 2.618h1.745v1.745H9.128zm0-6.982h1.745v5.236H9.128z"
  })));
};
export default SvgWarningIcon;